<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      value: this.item_value,
      d_check: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn]) ==
            this.item.displayOnValue
          : this.selectedItem[this.item.displayOn] == this.item.displayOnValue
        : false,
      d_check2: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn2] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn2]) ==
            this.item.displayOnValue2
          : this.selectedItem[this.item.displayOn2] == this.item.displayOnValue2
        : false,
      d_check3: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn3] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn3]) ==
            this.item.displayOnValue3
          : this.selectedItem[this.item.displayOn3] == this.item.displayOnValue3
        : false,
      disable_check:
        this.selectedItem &&
        this.item.disableOn &&
        this.selectedItem[this.item.disableOn]
          ? false
          : true,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    display_none_check2: {
      get: function () {
        return this.d_check2;
      },
      set: function (newValue) {
        this.d_check2 = newValue;
      },
    },
    display_none_check3: {
      get: function () {
        return this.d_check3;
      },
      set: function (newValue) {
        this.d_check3 = newValue;
      },
    },
    max_char_count() {
      const maxCount = {
        "Online Consultation - Accurx": {
          title: 25,
        },
      };
      if (this?.selectedItem) {
        const { title } = this.selectedItem;
        if (
          this.$route?.params?.categoryName === "banners" &&
          maxCount[title] &&
          maxCount[title].title
        ) {
          return Number(maxCount[title].title);
        }
      }

      return this.selectedItem?.character_count > 0
        ? this.selectedItem.character_count
        : 10000;
    },
  },
  watch: {
    last_updated: {
      handler() {
        this.handledisplay();
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    display_none_check2(val) {
      this.item.display = this.item.displayOn2 && !val ? false : true;
    },
    display_none_check3(val) {
      this.item.display = this.item.displayOn3 && !val ? false : true;
    },
  },
  mounted() {
    this.item.display = false;
  },
  methods: {
    handledisplay() {
      let val = this.last_updated;

      if (val && this.item.displayOn && val.key == this.item.displayOn) {
        if (typeof val.value == "object") {
          this.display_none_check =
            val.value.name == this.item.displayOnValue ? true : false;
        } else if (typeof val.value != "string") {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        } else {
          this.display_none_check =
            val.value == this.item.displayOnValue ? true : false;
        }
      }
      if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
        if (typeof val.value != "string") {
          this.display_none_check2 =
            JSON.stringify(val.value) == this.item.displayOnValue2
              ? true
              : false;
        } else {
          this.display_none_check2 =
            val.value == this.item.displayOnValue2 ? true : false;
        }
      }
      if (val && this.item.displayOn3 && val.key == this.item.displayOn3) {
        if (typeof val.value != "string") {
          this.display_none_check3 =
            JSON.stringify(val.value) == this.item.displayOnValue3
              ? true
              : false;
        } else {
          this.display_none_check3 =
            val.value == this.item.displayOnValue3 ? true : false;
        }
      }
      if (val && this.item.disableOn && val.key == this.item.disableOn) {
        let d_check = !val.value;
        // let d_check = val.value.find(x => JSON.stringify(x) == this.item.disableOnValue)
        this.disable_check = d_check ? true : false;
      }
    },
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{
      'd-none':
        (!item.apply_new_rule && item.displayOn && !display_none_check) ||
        (!item.apply_new_rule && item.displayOn2 && !display_none_check2) ||
        (!item.apply_new_rule && item.displayOn3 && !display_none_check3),
    }"
  >
    <Label
      v-if="!item.hideLabel"
      :item="item"
      :model_length="validation.$model.length"
    />
    <input
      v-model="value"
      :max="max_char_count"
      :maxlength="max_char_count"
      type="text"
      class="form-control"
      :class="{
        'is-invalid': submitted && validation.$error,
        'bg-soft-secondary':
          item.disableOn && disable_check
            ? true
            : this.$route.params.categoryName == 'globalupdate'
            ? false
            : selectedItem &&
              selectedItem.additionalProp1 &&
              selectedItem.additionalProp1.global
            ? true
            : item.disabled
            ? true
            : false,
      }"
      :disabled="
        item.disableOn && disable_check
          ? true
          : this.$route.params.categoryName == 'globalupdate'
          ? false
          : selectedItem &&
            selectedItem.additionalProp1 &&
            selectedItem.additionalProp1.global
          ? true
          : item.disabled
          ? true
          : false
      "
      :placeholder="item.placeholder"
    />
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
